export const CREDIT_MODE_ID = {
    NEW: '1',
    NOVATION: '2',
    REFINANCE: '4',
};

export const CREDIT_MODE = {
    NEW: 'NEW',
    NOVATION: 'NOVATION'
}

export const MODAL_MODE = {
    SINGLE: 'SINGLE',
    MULTIPLE: 'MULTIPLE'
}

export const MODAL_VIEW = {
    WRITE: 'WRITE',
    READONLY: 'READONLYU'
}

// Solo la línea de libranza se paga con descuento de nómina: es la única que
// tiene entidad pagadora y, por lo tanto, autorización de libranza que firmar.
export const CREDIT_LINE_ID = {
    LIBRANZA: '1',
};

export const CREDIT_STATE_ID = {
    ALL: '0',
    ACTIVE: '2',
    CLOSED: '3'
}